<template lang="pug">
chart(
  :type="type",
  :params="chartParams",
  :options="options",
  :benchmarkOptions="options",
  :benchmarkOpen="benchmarkOpen",
  :benchmarkEnabled="benchmarkEnabled",
  :public="public",
  :height="650"
)
  span(slot="extra-buttons", v-if="!public")
    b-form-select.btn-xs(
      v-model="aggregation",
      :options="aggregations",
      name="aggregation",
      size="sm"
    )
</template>

<script>
import Config from "next_report/config"
import { BFormSelect } from "bootstrap-vue"
import sum from "lodash/sum"
import Chart from "../Chart.vue"

const baseChart = (aggregation, categories, series, type) => Config.baseChart(false, series, {
  chart: { type },
  tooltip: Config.chartTemplates.sharedStackTooltip(false),
  legend: { enabled: true },
  xAxis: {
    categories,
  },
  yAxis: [
    {
      title: { text: "" },
      allowDecimals: false,
      labels: {
        format: "{value}",
      },
    },
  ],
})
export default {
  components: { Chart, BFormSelect },
  props: [
    "type",
    "update",
    "value",
    "params",
    "colors",
    "line",
    "public",
    "benchmarkOpen",
    "benchmarkEnabled",
  ],
  data() {
    return {
      aggregation: "monthly",
    }
  },
  computed: {
    chartParams() {
      const params = {}
      params.aggregation = this.aggregation
      params.update = this.update
      return Object.assign(params, this.params)
    },
    aggregations() {
      return [
        { text: "Monate", value: "monthly" },
        { text: "Wochen", value: "weekly" },
        { text: "Tage", value: "daily" },
      ]
    },
  },
  watch: {
    update() {
      this.aggregation = this.aggregation
    },
  },
  methods: {
    options(response) {
      if (this.line || this.aggregation == "daily") {
        var type = "line"
      } else {
        var type = "column"
      }

      this.$emit("input", response.statistics)
      const series = response.data.map((serie, i) => ({
        name: serie[0],
        color: (this.colors || [])[i] || Config.colors.own[i],
        data: Object.values(serie[1]).map((el) => el.count),
      }))
      return baseChart(
        this.aggregation,
        Object.keys(response.data[0][1]),
        series,
        type
      )
    },
  },
}
</script>

<style>
.dropdown-toggle.form-control {
  padding: 2px 24px 2px 5px !important;
  font-size: 12px !important;
}
</style>
